<template>
  <div class="relative">
    <label v-if="label != ''" :for="name" class="flex ai-c jc-sb">
      {{label}}
      <router-link v-if="extraLink != ''" :to="extraLink" class="text-primary">
        Clique aqui se você esqueceu sua senha!
      </router-link>
    </label>
    <div :class="[
      prefix !== '' && 'relative with-prefix',
      'input-cont-hint'
    ]">
      <input
        v-if="mask.length > 0"
        :class="error.message != '' ? `${className} has-error` : `${className}`"
        :id="name"
        :type="type"
        :name="name"
        :required="required"
        :placeholder="placeholder"
        :value="value"
        @input="$emit('input', $event.target.value)"
        @keyup="$emit('inputChanged', $event.target.value)"
        @blur="$emit('blur', $event.target.value)"
        v-mask="mask"
        :disabled="disabled"
        :style="addStyle"
      >

      <input
        v-else-if="money"
        :class="error.message != '' ? `${className} has-error` : `${className}`"
        :id="name"
        :type="type"
        :name="name"
        :required="required"
        :placeholder="placeholder"
        :value="value"
        v-money="moneyFormat"
        @input="$emit('input', $event.target.value)"
        @keyup="$emit('inputChanged', $event.target.value)"
        @blur="$emit('blur', $event.target.value)"
        :disabled="disabled"
        :style="addStyle"
      >

      <input
        v-else
        ref="inputText"
        :class="[
          error.message != '' ? `${className} has-error` : `${className}`
        ]"
        :id="name"
        :type="type"
        :name="name"
        :required="required"
        :placeholder="placeholder"
        :value="value"
        @input="$emit('input', $event.target.value)"
        @keyup="$emit('inputChanged', $event.target.value)"
        @blur="$emit('blur', $event.target.value)"
        :disabled="disabled"
        :style="addStyle"
      >

      <div class="prefix">
        {{prefix}}
      </div>
    </div>

    <div v-if="error.message != ''" :class="['field-error', errorBackgroundColor ? 'bg-error' : '']" class="mt-1">
      {{error.message}}
    </div>

    <div class="input-hint" v-if="hint">
      <p class="text-medium text-white">{{ hintMessage }}</p>
    </div>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';
import { VMoney } from 'v-money';

export default {
  name: 'Input',
  directives: {
    mask,
    money: VMoney,
  },
  data() {
    return {
      moneyFormat: {
        decimal: ',',
        thousands: '.',
      },
    };
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    required: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    error: {
      type: Error,
      default: () => new Error(''),
    },
    value: {},
    extraLink: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    mask: {
      type: Array,
      default: () => [],
    },
    money: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: String,
      default: '',
    },
    addStyle: {
      type: String,
      default: '',
    },
    hint: {
      type: Boolean,
      default: false,
    },
    hintMessage: {
      type: String,
      default: '',
    },
    onlyChars: {
      type: Boolean,
      default: false,
    },
    errorBackgroundColor: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.onlyChars) {
      this.$refs.inputText.addEventListener('keydown', this.onlyChar);
    }
    if (this.money) {
      if (this.value) {
        this.$emit('input', parseFloat(this.value).toFixed(2).replace('.', ','));
      }
    }
  },
  beforeDestroy() {
    if (this.onlyChars) {
      this.$refs.inputText.removeEventListener('keydown', this.onlyChar);
    }
  },
  methods: {
    onlyChar(e) {
      const keys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      if (keys.find((key) => key === e.key)) {
        e.preventDefault();
      }
    },
  },
};
</script>

<style scoped>
  .with-prefix input {
    padding-left: 40px;
  }

  .prefix {
    position: absolute;
    width: 40px;
    top: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .input-hint {
    position: absolute;
    bottom: calc(100% + 15px);
    background-color: var(--primary-color);
    padding: 0.75rem;
    border-radius: var(--medium-border-radius);
    text-align: left;
    opacity: 0;
    visibility: hidden;
    transition: var(--all-transition);
  }

  .input-hint::after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 10px 10px 0px 10px;
    border-color: var(--primary-color) transparent transparent transparent;
    position: absolute;
    top: 100%;
  }

  .input-cont-hint:hover ~ .input-hint {
    opacity: 1;
    visibility: visible;
  }

  .bg-error {
    background-color: unset !important;
  }
</style>
